import previewInterceptorMiddleware from "../middleware/previewInterceptor";
import headlessMiddleware from "../middleware/headless";
import headlessGlobalMiddleware from "../middleware/headless.global";
import redirectMiddleware from "../middleware/redirect";
import announcementsMiddleware from "../middleware/announcements";
import authMiddleWare from "../middleware/auth";
import { defineNuxtPlugin, addRouteMiddleware } from "#app";

export default defineNuxtPlugin( () => {
  addRouteMiddleware( "preview-interceptor", previewInterceptorMiddleware, { global: true } );
  addRouteMiddleware( "redirect-middleware", redirectMiddleware, { global: true } );
  addRouteMiddleware( "headless-global-middleware", headlessGlobalMiddleware, { global: true } );
  addRouteMiddleware( "announcements-middleware", announcementsMiddleware, { global: true } );
  addRouteMiddleware( "headless-middleware", headlessMiddleware );
  addRouteMiddleware( "auth-middleware", authMiddleWare, { global: true } );
} );
